<div class="col-12 d-flex justify-content-between align-items-center content-topbar">
    <div class="logo" [routerLink]="'/main'" tabindex="0">
        <div class="divimg">
            <img src="images/logo.png" alt="Food Villa">
        </div>
        <div class="logo-text">
            <span class="t1">FOOD VILLA</span>
            <span class="t2">ระบบจัดการตลาด</span>
        </div>
    </div>

    <nav class="menu-nav">
        <a *ngFor="let m of menu" [routerLink]="m.path" routerLinkActive="active">
            <span class="bubble"><i class="fa-solid" [ngClass]="m.icon"></i></span><span class="txt">{{m.label}}</span>
        </a>
    </nav>

    <div class="popup" (click)="$event.stopPropagation()">
        <button type="button" class="user-chip" (click)="triggerpopup()" [class.open]="showpopup">
            <span class="userimg"><i class="fa-solid fa-user"></i></span>
            <span class="uname">{{username}}</span>
            <i class="fa-solid fa-chevron-down caret"></i>
        </button>
        <div class="body-user" *ngIf="showpopup">
            <div class="ub-avatar"><i class="fa-solid fa-user"></i></div>
            <span class="title">{{username}}</span>
            <span class="pts"><i class="fa-solid fa-star me-1"></i>แต้มสะสม {{point}} คะแนน</span>
            <button class="btn btn-danger col-12" (click)="logout()"><i class="fa-solid fa-right-from-bracket me-2"></i>Log out</button>
        </div>
    </div>
</div>
